<template>
  <div class="cn-listing">
    <div v-for="control in filterControls(controls)" :key="control.id">
      <cn-control
        v-bind="$attrs"
        :data="control"
        :selectedSafeguards="selectedSafeguards"
        :hideUnselectedSafeguards="hideUnselectedSafeguards"
        :hideUnselectedControlSafeguards="
          hideUnselectedControlSafeguards.length > 0 &&
          hideUnselectedControlSafeguards.includes(control.id)
        "
        :getSafeguardMappings="getSafeguardMappings"
      />
    </div>
  </div>
</template>

<script>
import CISControlsNavigatorListingControl from './CIS-Controls-Navigator-Listing-Control.vue';

export default {
  name: 'CIS-Controls-Navigator-Listing',
  components: {
    CnControl: CISControlsNavigatorListingControl
  },
  props: {
    controls: {
      type: Array,
      default: () => []
    },
    selectedSafeguards: {
      type: Array,
      default: () => []
    },
    hideUnselectedSafeguards: {
      type: Boolean,
      default: false
    },
    hideUnselectedControlSafeguards: {
      type: Array,
      default: () => []
    },
    getSafeguardMappings: {
      type: Function,
      default: () => []
    }
  },
  methods: {
    filterControls(controls) {
      if (this.hideUnselectedSafeguards) {
        return controls.filter(
          (c) =>
            c.safeguards.some((s) => this.selectedSafeguards.includes(s.id)) ||
            this.hideUnselectedControlSafeguards.includes(c.id)
        );
      }
      return controls;
    }
  }
};
</script>
<style lang="scss" scoped>
.cn-listing {
  margin: 2.5rem 0 2rem 0;
  background-color: #ffffff;
  box-shadow: 0 -2px 5px 0 rgba(0, 0, 0, 0.02), 0 18px 17px 0 rgba(0, 0, 0, 0.08),
    0 2px 4px 0 rgba(0, 0, 0, 0.08);

  @include tablet-up {
    margin: 1rem 0 0 0;
    box-shadow: 0 17px 18px 0 rgba(0, 0, 0, 0.08), 0 3px 8px 0 rgba(0, 0, 0, 0.08);
  }
}
</style>
